
// TODO: Can be used of r predictive loading!

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},

  schema: {
    create({ prioidx }, data) {
      return {
        // cachedName:          cachedName,
        // commitmentTime:      -1,
        // commitmentWeekdays:  "xx-xx--",
        showFinished:           true,
        prioidx:                data.prioidx || 0, // This is the sortix of commitments inside a TSC
        userLeftGroup:          false,
        timeslotCollectionId:   data.timeslotCollectionId || '',
        // ### Graphical Representation {
        graphicalRepresentation: {
          fontFamily:   "Roboto",
          fontSize:     15,
          fill:         '#ffffff',
          show:         data.show === undefined ? true : data.show,
        },
        // ### }
      };
    },

    fields: {
      // cachedName: {},
      showFinished: {},
      prioidx: {},
      userLeftGroup: {},
      timeslotCollectionId: {},
      graphicalRepresentation: { validate_bolt_type: 'CommitmentGraphicalRepresentation' },
      'graphicalRepresentation/fontFamily': {},
      'graphicalRepresentation/fontSize': {},
      'graphicalRepresentation/fill': {},
      'graphicalRepresentation/show': {},
    }
  }
};
